import ExploreSelectBox from "@modules/new-explore/sidebar/filters/components/explore-selectbox";
import {
  ExploreBaseFilterSchema,
  ExploreCostFilterSchema,
  ExploreFilterComponentProps,
} from "@modules/new-explore/types";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExploreCost: React.FC<ExploreFilterComponentProps> = () => {
  const { filtersData } = useExplorePreloadedData();
  const data = (
    filtersData?.cost as ExploreBaseFilterSchema & ExploreCostFilterSchema
  ).data;
  return <ExploreSelectBox filterName="cost" item={data} />;
};

export default ExploreCost;
